function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.assign.js";
import React from 'react';
import { getDisplayPrice } from '@finect/front-utils/getDisplayPrice';
import { TrendingUp } from '@finect/tabular-icons/trendingUp';
import { getBaseURL } from '@finect/front-utils/env';
import { getProductPath, getProductTypeById, getProductDisplayName, getPeriodPerformance } from '@finect/front-resources/Products';
import { Icon } from '../Icon';
import { SquareImage } from '../SquareImage';
import { productTypes } from '../commons/productTypes';
import { InfoLabel } from '../Products/InfoLabel';
import { ProductItemLine, ProductName, ProductTag, Meta } from './ProductItemLine';
export var ProductItem = function ProductItem(_ref) {
  var subtype = _ref.subtype,
    entity = _ref.entity,
    withLink = _ref.withLink,
    withDate = _ref.withDate,
    nowrap = _ref.nowrap;
  var lastQuote = entity.lastQuote,
    currency = entity.currency,
    image = entity.image;
  var productType = getProductTypeById(subtype);
  var name = getProductDisplayName({
    subtype: subtype,
    entity: entity
  });
  var path = getProductPath({
    subtype: subtype,
    entity: entity
  });
  var _ref2 = lastQuote || {},
    price = _ref2.price;
  var linkProps = withLink ? {
    as: 'a',
    href: entity.link && entity.link.href || path.includes('undefined') ? null : path ? "".concat(getBaseURL()).concat(path) : "#"
  } : {};
  var isCaps = name === name.toUpperCase();
  var ytd = ['iic'].includes(productType === null || productType === void 0 ? void 0 : productType.category) ? entity.stats ? getPeriodPerformance(entity.stats, 'M0', 'accumulated') : null : null;
  var tile = React.createElement(SquareImage, {
    size: 1,
    margin: "0 19px 0 5px",
    alt: name,
    image: image,
    icon: React.createElement(TrendingUp, {
      strokeWidth: "1.2"
    })
  });
  if (subtype === 'service') {
    tile = React.createElement(Icon, {
      type: "company",
      size: 1,
      image: image ? "/image/".concat(image) : '',
      alt: name,
      margin: "0 19px 0 5px",
      withBorder: true,
      verified: true,
      small: true
    });
  }
  return React.createElement(ProductItemLine, _extends({}, linkProps, {
    nowrap: nowrap
  }), tile, React.createElement("div", null, React.createElement(ProductName, {
    capitalize: isCaps
  }, isCaps ? name.toLowerCase() : name), price && currency && React.createElement(ProductTag, null, getDisplayPrice(price, currency.code)), ['iic'].includes(productType === null || productType === void 0 ? void 0 : productType.category) ? React.createElement(InfoLabel, {
    value: ytd ? ytd.value : null,
    unit: "percent",
    label: "YTD",
    tooltip: {
      tip: 'Rentabilidad en el año',
      from: 'right'
    }
  }) : null, lastQuote && withDate ? React.createElement(Meta, {
    light: true
  }, new Date(lastQuote.datetime).toLocaleDateString('es-ES'), " ") : null, React.createElement(Meta, {
    light: true
  }, React.createElement("span", null, "\xB7"), productTypes[subtype] || subtype)));
};
export default React.memo(ProductItem);